import { ROOT_URL } from 'config'

export const isInternalURL = (url: string): boolean => {
  const rootUrl = new URL(ROOT_URL as string)
  const { host } = new URL(url, ROOT_URL)
  return host.endsWith(rootUrl.host)
}
